export default "__VITE_ASSET__DmOKYDAU__"